<template>
    <div>
        <div class="my_bottom_tab" v-if="nav">
            <div :class="['one',navIndex == '0'?'active':'']" @click="jumpTo('0')">
                <img v-if="navIndex == 0" src="@/assets/class.png" alt="">
                <img v-else src="@/assets/class_gray.png" alt="">
                <span>接龙列表</span>
            </div>
<!--            <div :class="['one',navIndex == '1'?'active':'']" @click="jumpTo('1')">
                <img v-if="navIndex == 1" src="@/assets/certificate.png" alt="">
                <img v-else src="@/assets/certificate_gray.png" alt="">
                <span>提现审核</span>
            </div>
            <div :class="['one',navIndex == '2'?'active':'']" @click="jumpTo('2')">
                <img v-if="navIndex == 2" src="@/assets/my_center.png" alt="">
                <img v-else src="@/assets/my_center_gray.png" alt="">
                <span>我的</span>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'nav',
                'navIndex'
            ]),
        },
        data() {
            return {
                tabIndex: '0'
            }
        },
        mounted() {
            console.log('nav555', this.nav)
            // this.$store.dispatch('changeNav', '0')
        },
        methods: {
            jumpTo(index){
                // this.tabIndex = index
                this.$store.dispatch('changeNav', index)
                if(index == '0'){
                    this.$router.push({
                        path: '/'
                    })
                }else if(index == '1'){
                    this.$router.push({
                        path: '/withdrawal'
                    })
                }else{
                    this.$router.push({
                        path: '/myPage'
                    })
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/flex.scss';
    .my_bottom_tab{
        @include lc-row-center;
        background: #fff;
        width: 100%;
        height: 60px;
        position: fixed;
        bottom: 0;
        left: 0;
        border-top: 1px solid #d8d8d8;
        .one{
            width: calc(100%/3);
            @include lc-row-column-center();
            font-size: 12px;
            img{
                width: 34px;
                height: 34px;
            }
            &.active{
                color:#3D4FBD;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/navbar/index.vue